import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ShareAccessCheckApi } from './apis/share-access-check-api';
import { ShareAccessCheckApiImpl } from './apis/impls/share-access-check-api';
import { ShareOwnerInfoApi } from './apis/share-owner-info-api';
import { ShareOwnerInfoApiImpl } from './apis/impls/share-owner-info-api';
import { ShareAccessCheckRepository, ShareOwnerInfoRepository } from './services/share-tools-repository';
import { ShareAccessCheckRepositoryImpl } from './repositories/impls/share-access-check-repository';
import { ShareOwnerInfoRepositoryImpl } from './repositories/impls/share-owner-info-repository';
import { AuthService } from './services/auth-service';
import { AuthServiceImpl } from './services/impls/auth-service';
import { AuthModel } from './models/auth.model';
import { AuthModelImpl } from './models/impls/auth.model';
import { ShareI18nService } from './services/share-i18n-service';
import { i18n } from '../i18n';

/**
 * 最小化的 authModule，只包含 AuthService 及其依赖
 * 适用于只需要权限检查功能的项目
 */
export const authModule = new ContainerModule((bind) => {
    bind(ShareI18nService).toConstantValue({
        t: i18n.global.t.bind(i18n),
        locale: i18n.global.locale.value,
    });
    // AuthService 依赖
    bind(ShareAccessCheckApi).to(ShareAccessCheckApiImpl);
    bind(ShareOwnerInfoApi).to(ShareOwnerInfoApiImpl);
    bind(ShareAccessCheckRepository).to(ShareAccessCheckRepositoryImpl);
    bind(ShareOwnerInfoRepository).to(ShareOwnerInfoRepositoryImpl);
    bind(AuthService).to(AuthServiceImpl);
    bind(AuthModel).to(AuthModelImpl);
});
